import { MenuIcon, PanelLeftCloseIcon, PanelLeftOpenIcon, UserIcon } from 'lucide-react'
import type { ReactNode } from 'react'
import { useT } from '@/session/useSession'
import { IconButton } from '../IconButton/IconButton'
import { IconLink } from '../IconLink/IconLink'
import { LocaleToggle } from '../LocaleToggle/LocaleToggle'
import { TextSizeToggle } from '../TextSizeToggle/TextSizeToggle'
import { ThemeToggle } from '../ThemeToggle/ThemeToggle'
import styles from './Header.module.css'

export type HeaderProps = {
  actions?: ReactNode

  collapsed: boolean
  onToggleRail: () => void
  drawerOpen: boolean
  onOpenDrawer: () => void
  profilePath: string
  profileLabelKey: string
}

export function Header({
  actions,
  collapsed,
  onToggleRail,
  drawerOpen,
  onOpenDrawer,
  profilePath,
  profileLabelKey,
}: HeaderProps) {
  const t = useT()

  return (
    <header className={styles.header}>
      <IconButton
        className={styles.menu}
        label={t('layouts.main.toggle_menu')}
        aria-expanded={drawerOpen}
        onClick={onOpenDrawer}
      >
        <MenuIcon />
      </IconButton>
      <IconButton
        className={styles.rail}
        label={t('layouts.main.toggle_menu')}
        aria-expanded={!collapsed}
        onClick={onToggleRail}
      >
        {collapsed ? <PanelLeftOpenIcon /> : <PanelLeftCloseIcon />}
      </IconButton>
      {actions}
      <TextSizeToggle />
      <ThemeToggle />
      <LocaleToggle />
      <IconLink to={profilePath} label={t(profileLabelKey)}>
        <UserIcon />
      </IconLink>
    </header>
  )
}
